export const IRREGULARITIES_ENDPOINT = 'irregularity-types'

export const IRREGULARITIES_TABLE_KEY = 'winter-service-v2-settings-irregularities'
export const IRREGULARITIES_UI_VIEW = 'winter_service2_settings_irregularities'

// The backend keeps the irregularity type's label in a `description` column and
// exposes the active flag as a boolean `is_active` (derived from
// `deactivated_at`), so those are the keys the table rows and the payloads use.
export const IRREGULARITY_DESCRIPTION_KEY = 'description'
export const IRREGULARITY_IS_ACTIVE_KEY = 'is_active'

// `filters.is_active` is read through FILTER_VALIDATE_BOOLEAN on the backend, so
// the filter has to hand it something boolean-ish rather than our
// active/inactive status strings.
export const IRREGULARITY_IS_ACTIVE_FILTER_VALUES = {
  active: 'true',
  inactive: 'false'
}
